require('./brokerStocksAdvancedBuyStep1.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { connect } = require('react-redux');
const classNames = require('classnames');

// @ commons
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { RadioButton } = require('commonsComponents/radioButton');
const BuySellConditionTypeDropdown = require('components/broker/commons/buySellConditionTypeDropdown/buySellConditionTypeDropdown');
const DatePickerCustom = require('components/datePickerCustom/datePickerCustom');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');

// @ helpers
const { formatText, FormattedText, getLanguage } = require('core/i18n').i18n;
const {
    FIRST_STEP,
    BROKER_CONDITIONAL_ORDER_TERM,
    BROKER_RESTRICTED_ORDER_TERM,
    BROKER_INDEX_ORDER_CONDITION_VALUE,
    BROKER_DAILY_LOWERING_PERCENTAGE_GRATER_THAN_CONDITION_ID,
    BROKER_DAILY_RACING_PERCENTAGE_GRATER_THAN_CONDITION_ID,
    BROKER_INTRADAY_DOWN_VARIATION_PERCENTAGE_GRATER_THAN_CONDITION_ID,
    BROKER_INTRADAY_UP_VARIATION_PERCENTAGE_GRATER_THAN_CONDITION_ID,
    BROKER_INPUT_SEARCH_ONLYSTOCKS_MODIFIER,
    EURO_TEXT,
    MAX_FRACTION_LENGTH_IN_STORE,
    TYPE_STOCKS,
    SPANISH_CONTINUES_MARKET_ISO_CODE,
    SPANISH_CONTINUES_MARKET_ISO_CODE_ONLY_STOCK
} = require('constants/index');
const language = getLanguage();
const { DATE_PICKER_CUSTOM_PLACEHOLDER, DATE_PICKER_CUSTOM_LOCALE, DATE_PICKER_CUSTOM_DATE_FORMAT } = require('constants/commonsComponents');

// @ actions
const BrokerStocksAdvancedBuyActions = require('actions/brokerStocksAdvancedBuy');
const BrokerSearchActions = require('actions/brokerSearch');

// @ components
const BrokerSearchInput = require('components/broker/brokerSearch/brokerSearchInput/brokerSearchInput');
const { AmountInput } = require('commonsComponents/amountInput');

class BrokerStocksAdvancedBuyStep1 extends React.Component {
    constructor(props) {
        super(props);
        this.handleConditionTypeValueChanged = this.handleConditionTypeValueChanged.bind(this);
    }

    buildAmountOrPointsField() {
        const { immBrokerStocksAdvancedBuy, handleConditionTypeValueChanged } = this.props;
        const conditionTypeValue = immBrokerStocksAdvancedBuy.getIn([
            'steps',
            FIRST_STEP,
            'conditionTypeValue'
        ]);

        return (
            <div className="stocks-advanced-buy-step1__condition-type-value-input">
                <AmountInput
                    id="conditionValue"
                    callback={handleConditionTypeValueChanged}
                    amount={conditionTypeValue}
                    errorMsg={formatText('broker-stocksAdvancedBuyStep1OrderTypeValueError')}
                    error={immBrokerStocksAdvancedBuy.getIn(['steps', FIRST_STEP, 'orderConditionError'])}
                    maxBackEndFractionLength={MAX_FRACTION_LENGTH_IN_STORE}
                    language={language}
                    hideFocusZero
                />
            </div>
        );
    }

    buildConditionTypeValueSection() {
        const { immBrokerStocksAdvancedBuy } = this.props;
        const conditionType = immBrokerStocksAdvancedBuy.getIn([
            'steps',
            FIRST_STEP,
            'conditionType'
        ]);
        const orderConditionValue = immBrokerStocksAdvancedBuy.getIn([
            'steps',
            FIRST_STEP,
            'orderConditionValue'
        ]);
        let conditionTypeValueField;
        let conditionTypeValueFieldLabelKey;
        let conditionTypeValueFieldLabelKeyParams;

        switch (conditionType) {
            case BROKER_DAILY_LOWERING_PERCENTAGE_GRATER_THAN_CONDITION_ID:
            case BROKER_DAILY_RACING_PERCENTAGE_GRATER_THAN_CONDITION_ID:
            case BROKER_INTRADAY_DOWN_VARIATION_PERCENTAGE_GRATER_THAN_CONDITION_ID:
            case BROKER_INTRADAY_UP_VARIATION_PERCENTAGE_GRATER_THAN_CONDITION_ID:
                conditionTypeValueField = this.buildPercentageField();
                conditionTypeValueFieldLabelKey =
                    'broker-stocksAdvancedBuyConditionTypePercentageValue';
                conditionTypeValueFieldLabelKeyParams = [];
                break;
            default:
                conditionTypeValueField = this.buildAmountOrPointsField();
                conditionTypeValueFieldLabelKey =
                    'broker-stocksAdvancedBuyConditionTypeAmountOrPointsValue';
                conditionTypeValueFieldLabelKeyParams = [
                    orderConditionValue === BROKER_INDEX_ORDER_CONDITION_VALUE
                        ? formatText('broker-pointsText')
                        : EURO_TEXT
                ];
                break;
        }

        return (
            <div className="stocks-advanced-buy-step1__condition-type-value-section">
                <FormattedText
                    value={conditionTypeValueFieldLabelKey}
                    injectedStrings={conditionTypeValueFieldLabelKeyParams}
                    className="stocks-advanced-buy-step1__condition-type-value-label"
                />
                {conditionTypeValueField}
            </div>
        );
    }

    buildDynamicSection() {
        const {
            immBrokerStocksAdvancedBuy,
            immSearchState,
            handleInputSearchOnSearch,
            handleConditionTypeChanged,
            handleResetSelectedValues,
            handleInputSearchProductSelected,
            orderTermValidityDateChanged
        } = this.props;

        const step1 = immBrokerStocksAdvancedBuy.getIn(['steps', FIRST_STEP]);
        const excludeDates = step1.get('excludeDates');
        const orderTerms = step1.get('orderTerms');
        const isInputSearchFetching = immSearchState.get('isFetching');
        const orderConditionValue = step1.get('orderConditionValue');
        const conditionType = step1.get('conditionType');
        const conditionTypeValueSection = this.buildConditionTypeValueSection();
        const limitDate = step1.get('limitDate');
        const validityDate = step1.get('validityDate');
        const firstDate = step1.get('firstDate');
        const stockId = step1.get('stockId');
        const stockError = step1.get('stockError');

        let dinamycSection = (
            <FormattedText
                value="broker-stocksAdvancedBuyEverithingOrNothing"
                className="stocks-advanced-buy-step1__restricted-order-text"
            />
        );

        const inputSearchResults = immSearchState.get('results').filter(item =>
            item.get('type') === TYPE_STOCKS &&
            (
                item.getIn(['id', 'iso']) === SPANISH_CONTINUES_MARKET_ISO_CODE ||
                item.getIn(['id', 'iso']) === SPANISH_CONTINUES_MARKET_ISO_CODE_ONLY_STOCK
            )

        );

        if (orderTerms === BROKER_CONDITIONAL_ORDER_TERM) {
            dinamycSection = (
                <div className="stocks-advanced-buy-step1__group-div">
                    <h3 className="stocks-advanced-buy-step1__section-title">
                        <FormattedText value="broker-stocksAdvancedBuyOrderConditionTypeSectionTitle" />
                    </h3>
                    <div className="stocks-advanced-buy-step1__subgroup-div">
                        <h4 className="stocks-advanced-buy-step1__section-subtitle">
                            <FormattedText value="broker-stocksAdvancedBuyOrderConditionValueSubtitle" />
                            <OKTooltip
                                content="broker-stocksAdvancedBuyOrderConditionValueTooltip"
                                offset={[0, -15]}
                            />
                        </h4>
                        <div className="stocks-advanced-buy-step1__stock">
                            <div className="stocks-advanced-buy-step1__stock-title">
                                <FormattedText value="broker-stocksAdvancedBuyStocksConditionValue" />
                            </div>
                            <div className="stocks-advanced-buy-step1__search-input">
                                <BrokerSearchInput
                                    placeholder={formatText(
                                        'broker-stocksAdvancedBuySearchPlaceholder'
                                    )}
                                    noResultsText={formatText('broker-searchEmptyText')}
                                    isLoading={isInputSearchFetching}
                                    results={inputSearchResults}
                                    onSearch={handleInputSearchOnSearch}
                                    onSelection={handleInputSearchProductSelected}
                                    selectedValue={stockId}
                                    resetSelectedValuesOnInput={true}
                                    onResetSelectedValues={handleResetSelectedValues}
                                    modifier={BROKER_INPUT_SEARCH_ONLYSTOCKS_MODIFIER}
                                    resetWhenMounting={false}
                                    errorState={stockError}
                                    errorMessage={formatText(
                                        'broker-stocksAdvancedBuyStep1StockError'
                                    )}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="stocks-advanced-buy-step1__subgroup-div">
                        <h4 className="stocks-advanced-buy-step1__section-subtitle">
                            <FormattedText value="broker-stocksAdvancedBuyDriverEventSubtitle" />
                            <OKTooltip
                                content="broker-stocksAdvancedBuyDriverEventTooltip"
                                offset={[0, -5]}
                            />
                        </h4>
                        <div className="stocks-advanced-buy-step1__condition-type-dropdown">
                            <BuySellConditionTypeDropdown
                                onConditionTypeChange={handleConditionTypeChanged}
                                selectedValue={conditionType}
                                isConditionOnMarketIndex={
                                    orderConditionValue === BROKER_INDEX_ORDER_CONDITION_VALUE
                                }
                            />
                        </div>
                        {conditionTypeValueSection}
                    </div>
                    <div className="stocks-advanced-buy-step1__subgroup-div">
                        <h4 className="stocks-advanced-buy-step1__section-subtitle stocks-advanced-buy-step1__clear">
                            <FormattedText value="broker-stocksAdvancedBuyValidityDateSubtitle" />
                            <OKTooltip
                                content="broker-stocksAdvancedBuyValidityDateTooltip"
                                offset={[0, -15]}
                            />
                        </h4>
                        <div className="stocks-advanced-buy-step1__date-picker">
                            <DatePickerCustom
                                callback={orderTermValidityDateChanged}
                                selectedDate={validityDate}
                                newSelectedDate={validityDate}
                                maxDate={limitDate}
                                minDate={firstDate}
                                excludeDates={excludeDates}
                                placeholder={formatText(DATE_PICKER_CUSTOM_PLACEHOLDER)}
                                locale={formatText(DATE_PICKER_CUSTOM_LOCALE)}
                                dateFormat={formatText(DATE_PICKER_CUSTOM_DATE_FORMAT)}
                            />
                        </div>
                    </div>
                </div>
            );
        }

        return dinamycSection;
    }

    buildPercentageField() {
        const { immBrokerStocksAdvancedBuy } = this.props;
        const conditionTypeValue = immBrokerStocksAdvancedBuy.getIn([
            'steps',
            FIRST_STEP,
            'conditionTypeValue'
        ]);
        const callback = this.handleConditionTypeValueChanged;
        return (
            <div className="stocks-advanced-buy-step1__condition-type-value-input">
                <AmountInput
                    amount={conditionTypeValue}
                    autoComplete="off"
                    maxFractionLength={0}
                    callback={callback}
                    errorMsg={formatText('broker-stocksAdvancedBuyStep1OrderTypeValueError')}
                    error={immBrokerStocksAdvancedBuy.getIn([
                        'steps',
                        FIRST_STEP,
                        'orderConditionError'
                    ])}
                    language={language}
                    hideFocusZero
                />
            </div>
        );
    }

    handleConditionTypeValueChanged(value) {
        this.props.handleConditionTypeValueChanged(value);
    }

    render() {
        const { immBrokerStocksAdvancedBuy, handleOrderTermsChanged } = this.props;

        const step1 = immBrokerStocksAdvancedBuy.getIn(['steps', FIRST_STEP]);
        const orderTerms = step1.get('orderTerms');
        const dynamicSection = this.buildDynamicSection();
        const orderTermsSectionClassesGroup = classNames(
            'stocks-advanced-buy-step1__group-div',
            'hidden',
            {
                'stocks-advanced-buy-step1__group-div--no-margin':
                    orderTerms === BROKER_RESTRICTED_ORDER_TERM
            }
        );
        const orderTermsSectionClassesSubgroup = classNames(
            'stocks-advanced-buy-step1__subgroup-div',
            {
                'stocks-advanced-buy-step1__subgroup-div--no-margin':
                    orderTerms === BROKER_RESTRICTED_ORDER_TERM
            }
        );

        return (
            <div className="stocks-advanced-buy-step1">
                <header className="stocks-advanced-buy-step1__header">
                    <h2 className="stocks-advanced-buy-step1__header-title">
                        <FormattedText value="broker-stocksAdvancedBuyHeaderTitle" />
                    </h2>
                </header>
                <section className={orderTermsSectionClassesGroup}>
                    <h3 className="stocks-advanced-buy-step1__section-title">
                        <FormattedText value="broker-stocksAdvancedBuyAdvancedOrderTypeSectionTitle" />
                    </h3>
                    <div className={orderTermsSectionClassesSubgroup}>
                        <h4 className="stocks-advanced-buy-step1__section-subtitle">
                            <FormattedText value="broker-stocksAdvancedBuyOrderTypeSubtitle" />
                            <OKTooltip
                                content="broker-todoTooltip"
                                offset={[0, -15]}
                            />
                        </h4>
                        <RadioButtonGroup
                            selectedValue={orderTerms}
                            onChange={handleOrderTermsChanged}
                            name="orderTermsRadioGroup"
                            idPrefix="orderTermsRadioGroup"
                        >
                            <RadioButton
                                label={formatText('broker-stocksAdvancedBuyConditionalOrderTerm')}
                                value={BROKER_CONDITIONAL_ORDER_TERM}
                                className="stocks-advanced-buy-step1__radio-button"
                            />
                            <RadioButton
                                label={formatText('broker-stocksAdvancedBuyRestrictedOrderTerm')}
                                value={BROKER_RESTRICTED_ORDER_TERM}
                                className="stocks-advanced-buy-step1__radio-button"
                            />
                        </RadioButtonGroup>
                    </div>
                </section>
                {dynamicSection}
            </div>
        );
    }
}

BrokerStocksAdvancedBuyStep1.propTypes = {
    immBrokerStocksAdvancedBuy: PropTypes.object.isRequired,
    immSearchState: PropTypes.object.isRequired,
    handleOrderTermsChanged: PropTypes.func.isRequired,
    handleResetSelectedValues: PropTypes.func.isRequired,
    handleInputSearchOnSearch: PropTypes.func.isRequired,
    handleInputSearchProductSelected: PropTypes.func.isRequired,
    handleConditionTypeChanged: PropTypes.func.isRequired,
    handleConditionTypeValueChanged: PropTypes.func.isRequired,
    orderTermValidityDateChanged: PropTypes.func.isRequired
};

module.exports.constructor = BrokerStocksAdvancedBuyStep1;

module.exports.BrokerStocksAdvancedBuyStep1 = connect(
    state => ({
        immBrokerStocksAdvancedBuy: state.brokerStocksAdvancedBuy,
        immSearchState: state.brokerSearch
    }),
    {
        handleOrderTermsChanged: BrokerStocksAdvancedBuyActions.orderTermsChanged,
        handleResetSelectedValues: BrokerSearchActions.resetSelectedResults,
        handleInputSearchOnSearch: BrokerSearchActions.searchAllProducts,
        handleInputSearchProductSelected: BrokerStocksAdvancedBuyActions.inputSearchProductSelected,
        handleConditionTypeChanged: BrokerStocksAdvancedBuyActions.conditionTypeChanged,
        handleConditionTypeValueChanged: BrokerStocksAdvancedBuyActions.conditionTypeValueChanged,
        orderTermValidityDateChanged: BrokerStocksAdvancedBuyActions.orderTermValidityDateChanged
    }
)(BrokerStocksAdvancedBuyStep1);
